import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { branchesAPI as API } from "../../apis/branches";
import { RootState } from "../store";

export const loadBranches = createAsyncThunk(
  "branches/load",
  (page: number = 1) => API.fetchPage(page),
  {
    condition: (page, { getState }: any) => {
      const { branches } = getState() as RootState;
      if (branches.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Branch>();
interface Branches extends EntityState<Branch> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: Branches = {
  ...itemsAdapter.getInitialState(),
  status: "idle",
};

const slice = createSlice({
  name: "branches",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadBranches.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadBranches.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadBranches.fulfilled, (state, { payload }) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, payload.data);
      });
  },
});

export default slice.reducer;
